module.exports = __webpack_public_path__ + "img/red_039.494e6cb8.png";